import {
  REACT_APP_BASE_URL_JANUS,
  REACT_APP_BASE_URL_EMAIL_SERVICE,
  corsBypass,
} from "../constants/enviroments";
import axios from "axios";
import { interceptorHelper } from "./interceptor";
import { handleAxiosError } from "./Axios";

let JanusAxios = axios.create({
  baseURL: `${
    process.env.NODE_ENV === "development" ? corsBypass : ""
  }${REACT_APP_BASE_URL_JANUS}`,
});

JanusAxios.interceptors.request.use(
  interceptorHelper.config,
  interceptorHelper.error
);

JanusAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return handleAxiosError(error);
  }
);

export async function updateUserInformation(data) {
  return JanusAxios.patch(`/settings/me`, data);
}

export async function updateUserVisibility(data) {
  return JanusAxios.patch(`/settings/visibility`, data);
}

export async function changeUserPassword(data) {
  return JanusAxios.patch(`/settings/password`, data);
}

export async function sendEmail(data, type) {
  return axios.post(
    `${REACT_APP_BASE_URL_EMAIL_SERVICE}/share/${
      type === "Profile" ? "link" : "cohort"
    }`,
    data
  );
}

export async function initializeStripePayment(data) {
  return JanusAxios.post(`/orders/initialize`, data);
}

export async function StartMeetingRecording(data) {
  return JanusAxios.post(`/call/start-recording`, data);
}

export async function StopMeetingRecording(data) {
  return JanusAxios.post(`/call/stop-recording`, data);
}

export async function saveUserBankInfo(data) {
  return JanusAxios.post(`/payout/account`, data);
}

export const getBalances = () => {
  return JanusAxios.get(`/users/balances`);
};
